<template>
  <div class="footer">
    <div class="footer-container">
      <div class="footer-container-header">
        <img src="../assets/img/logo.png" alt="">
        <div class="header-right">
          <div class="header-right-middle">{{ phone }}</div>
          <div class="header-right-bottom">苏州工业园区东平街268号园科大厦3楼</div>
        </div>
      </div>
      <div class="footer-container-content">
        <div class="content-left">
          <div class="content-left-item">
            <div class="item-title" @click="goroute('/service')">产品服务</div>
            <div class="item-text" @click="goroute('/service')">地理信息服务</div>
            <div class="item-text" @click="goroute('/service')">三维模型制作</div>
            <div class="item-text" @click="goroute('/service')">三维扫描数字化</div>
            <div class="item-text" @click="goroute('/service')">智慧政务平台开发</div>
          </div>
          <div class="content-left-item">
            <div class="item-title" @click="goroute('/news')">新闻中心</div>
            <div class="item-text" @click="goroute('/news')">公司动态</div>
            <div class="item-text" @click="goroute('/news')">行业新闻</div>
          </div>
          <div class="content-left-item">
            <div class="item-title" @click="goroute('/about')">关于我们</div>
            <div class="item-text" @click="goroute('/about')">公司介绍</div>
            <div class="item-text" @click="goroute('/about')">企业文化</div>
            <div class="item-text" @click="goroute('/about')">企业特色</div>
            <div class="item-text" @click="goroute('/contact')">联系我们</div>
          </div>
        </div>
        <img src="../assets/img/QR code.png" alt="">
      </div>
      <div class="footer-container-foot">
        <div class="foot-left">CopyRight © 2021 All Right Reserved 苏州山湖测绘科技有限公司 版权所有</div>
        <div class="foot-right">苏ICP备20032249号-1</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      phone: ''
    }
  },
  methods: {
    goroute(path) {
      this.$router.push({ path: path })
    },
  },
  created() {
    const that = this
    fetch('https://szshsurvey.com/smc_resource/json/lyc/info.json').then(d => {
      d.json().then(res => {
        console.log(res);
        that.phone = res.phone

      })
    }).catch(err => {
      console.log(err)
    })
  }
};
</script>
<style lang="scss" scoped>
.footer {
  width: 100%;
  height: 100%;

  &-container {
    width: 12rem;
    height: 100%;
    margin: 0 auto;

    &-header {
      width: 100%;
      height: 1.54rem;
      padding: 0.24rem 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-sizing: border-box;
      color: #e9e9e9;
      box-shadow: 0px 1px 0px 0px #505050;

      .header-right {
        height: 100%;
        text-align: right;

        &-middle {
          font-size: 0.26rem;
          margin: 0.1rem 0;
        }

        &-bottom {
          font-size: 0.14rem;
        }
      }

    }

    &-content {
      width: 100%;
      height: 2.73rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: #3c3c3c;
      border-top: 1px solid #505050;
      border-bottom: 1px solid #505050;
      padding: 0.4rem 0;
      box-sizing: border-box;

      .content-left {
        width: calc(100% - 2rem);
        height: 100%;
        display: flex;
        justify-content: flex-start;

        &-item {
          margin-right: 0.5rem;
          min-width: 1.3rem;
          cursor: pointer;

          .item-title {
            font-size: 0.14rem;
            color: #e9e9e9;
            margin-bottom: 0.17rem;
          }

          .item-text {
            font-size: 0.12rem;
            color: #999999;
            margin-bottom: 0.12rem;
          }
        }
      }
    }

    &-foot {
      width: 100%;
      height: 0.96rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 0.14rem;
      color: #777777;
    }
  }
}
</style>
